"use strict";

import autocomplete from './phphelpers/autocomplete';
import dateInterval from './phphelpers/dateInterval';
import date from './phphelpers/date';
import time from './phphelpers/time';
import cnpj from './phphelpers/cnpj';
import select from './phphelpers/select';
import addActivatedBy from './phphelpers/addActivatedBy';
import {DATA_ATTRIBUTES} from "./utils";


export const UI = {
    PHPHelper: {
        autocomplete: autocomplete,
        date: date,
        dateInterval: dateInterval,
        select: select,
        time: time,
        cnpj: cnpj,
        addActivatedBy: addActivatedBy,
    },
    multiAutocomplete: {
        /**
         *
         * @param id
         * @returns MultiAutocomplete
         */
        get: (id) => {
            return $("#" + id).data(DATA_ATTRIBUTES.multiAutocomplete)
        }
    },

    autocomplete: {
        /**
         *
         * @param id
         * @returns Autocomplete
         */
        get: (id) => {
            return $("#" + id).data(DATA_ATTRIBUTES.autocomplete)
        }
    },
}

export default UI
